import React from "react";
import { CommodityDetail } from "features/contracts/enums/commodityDetail";
import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import Icon from "features/shared/components/icons/Icon";
import { Commodity } from "features/shared/enums/commodity";

interface IProps {
  commodityDetail?: CommodityDetail;
  commodity?: Commodity;
  includeColor?: boolean;
  size?: SizeProp;
  isProduction?: boolean;
}

const CommodityIcon: React.FC<IProps> = (props) => {
  // helpers
  const getElectricityColor = () => {
    if (props.isProduction) {
      return "text-production";
    } else {
      return "text-electricity";
    }
  };

  // render
  if (props.commodityDetail) {
    switch (props.commodityDetail) {
      case CommodityDetail.ElectricityCustomer:
      case CommodityDetail.ElectricitySupplier:
        if (props.includeColor)
          return (
            <span className={getElectricityColor()}>
              <Icon icon="bolt" size={props.size} />
            </span>
          );
        else return <Icon icon="bolt" size={props.size} />;
      case CommodityDetail.GasCustomer:
      case CommodityDetail.GasSupplier:
        if (props.includeColor)
          return (
            <span className="text-gas">
              <Icon icon="fire" size={props.size} />
            </span>
          );
        else return <Icon icon="fire" size={props.size} />;
      case CommodityDetail.HeatCustomer:
        if (props.includeColor)
          return (
            <span className="text-heat">
              <Icon icon="thermometer-three-quarters" size={props.size} />
            </span>
          );
        else
          return <Icon icon="thermometer-three-quarters" size={props.size} />;
      case CommodityDetail.eMobility:
        if (props.includeColor)
          return (
            <span className="text-emobility">
              <Icon icon="charging-station" size={props.size} />
            </span>
          );
        else return <Icon icon="charging-station" size={props.size} />;
      case CommodityDetail.Undefined:
        if (props.includeColor)
          return (
            <span className="text-muted">
              <Icon icon="file-alt" size={props.size} />
            </span>
          );
        else return <Icon icon="file-alt" size={props.size} />;
      default:
        if (props.includeColor)
          return (
            <span className="text-muted">
              <Icon icon="file-alt" size={props.size} />
            </span>
          );
        else return <Icon icon="file-alt" size={props.size} />;
    }
  } else if (props.commodity) {
    switch (props.commodity) {
      case Commodity.Electricity:
        if (props.includeColor)
          return (
            <span className={getElectricityColor()}>
              <Icon icon="bolt" size={props.size} />
            </span>
          );
        else return <Icon icon="bolt" size={props.size} />;
      case Commodity.Gas:
        if (props.includeColor)
          return (
            <span className="text-gas">
              <Icon icon="fire" size={props.size} />
            </span>
          );
        else return <Icon icon="fire" size={props.size} />;
      case Commodity.Heat:
        if (props.includeColor)
          return (
            <span className="text-heat">
              <Icon icon="thermometer-three-quarters" size={props.size} />
            </span>
          );
        else
          return <Icon icon="thermometer-three-quarters" size={props.size} />;
      default:
        if (props.includeColor)
          return (
            <span className="text-muted">
              <Icon icon="file-alt" size={props.size} />
            </span>
          );
        else return <Icon icon="file-alt" size={props.size} />;
    }
  } else {
    if (props.includeColor)
      return (
        <span className="text-muted">
          <Icon icon="file-alt" size={props.size} />
        </span>
      );
    else return <Icon icon="file-alt" size={props.size} />;
  }
};

export default CommodityIcon;
